import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./App.css";

// Import components
import Login from "./pages/Auth/Login";
import Register from "./pages/Auth/Register";
import ProtectedRoute from "./components/ProtectedRoute";
import BuyerPage from "./pages/buyerPage";
import SellerPage from "./pages/sellerPage";
import AdminDashboard from "./pages/adminDashboard";
import SuperAdminDashboard from "./pages/superAdminDashboard";
// Admin pages
import AdminUsers from "./pages/adminPages/Users";
import AdminTransactions from "./pages/adminPages/Transactions";
import AdminReports from "./pages/adminPages/Reports";
// Super admin pages
import SAUsers from "./pages/superAdminPages/Users";
import SATransactions from "./pages/superAdminPages/Transactions";
import SAReports from "./pages/superAdminPages/Reports";
import SAAdmins from "./pages/superAdminPages/Admins";
import SALogs from "./pages/superAdminPages/Logs";
// seller pages
import SellerRequests from "./pages/sellerPages/Requests";
import SellerTransactions from "./pages/sellerPages/Transactions";
import SellerMylistings from "./pages/sellerPages/mylistings";
import SellerListingDetails from "./pages/sellerPages/ListingDetails";
import SellerMyProfile from "./pages/sellerPages/myProfile";
import SellerAccountDetails from "./pages/sellerPages/accountSettings";
// seller pages
import BuyerRequests from "./pages/buyerPages/Requests";
import BuyerTransactions from "./pages/buyerPages/Transactions";
import BuyerMylistings from "./pages/buyerPages/mylistings";
import BuyerListingDetails from "./pages/buyerPages/ListingDetails";
import { AuthProvider } from "./context/authContext";
import BuyerListingOfferDetails from "./pages/buyerPages/OffersDetails";
import PaymentInstructionsPage from "./pages/payment/paymentPage";
import TransactionDetails from "./pages/buyerPages/TransDetails";
import BuyerInvoice from "./pages/buyerPages/Invoice";
import SellerInvoice from "./pages/sellerPages/Invoice";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import HomePage from "./pages/homePage";
import PublicListingDetails from "./pages/publicPages/PublicListingDetails";

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/" element={<HomePage />} />
            <Route path="/listing/:id" element={<PublicListingDetails />} />

            {/* payment instructions Routes */}
            <Route
              path="/buyer/payment-initiate/:id"
              element={
                <ProtectedRoute allowedRoles={["buyer"]} redirectTo="/">
                  <PaymentInstructionsPage />
                </ProtectedRoute>
              }
            />

            {/* buyer Routes */}
            <Route
              path="/buyer"
              element={
                <ProtectedRoute allowedRoles={["buyer"]} redirectTo="/">
                  <BuyerPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/buyer/listings"
              element={
                <ProtectedRoute allowedRoles={["buyer"]} redirectTo="/">
                  <BuyerMylistings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/buyer/listings/:id"
              element={
                <ProtectedRoute allowedRoles={["buyer"]} redirectTo="/">
                  <BuyerListingDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/buyer/requests/:id/offer"
              element={
                <ProtectedRoute allowedRoles={["buyer"]} redirectTo="/">
                  <BuyerListingOfferDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/buyer/transactions/:id/details"
              element={
                <ProtectedRoute allowedRoles={["buyer"]} redirectTo="/">
                  <TransactionDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/buyer/transactions/:id/invoice"
              element={
                <ProtectedRoute allowedRoles={["buyer"]} redirectTo="/">
                  <BuyerInvoice />
                </ProtectedRoute>
              }
            />
            <Route
              path="/buyer/requests"
              element={
                <ProtectedRoute allowedRoles={["buyer"]} redirectTo="/">
                  <BuyerRequests />
                </ProtectedRoute>
              }
            />
            <Route
              path="/buyer/transactions"
              element={
                <ProtectedRoute allowedRoles={["buyer"]} redirectTo="/">
                  <BuyerTransactions />
                </ProtectedRoute>
              }
            />

            {/* seller Routes */}
            <Route
              path="/seller"
              element={
                <ProtectedRoute allowedRoles={["seller"]} redirectTo="/">
                  <SellerPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/seller/listings"
              element={
                <ProtectedRoute allowedRoles={["seller"]} redirectTo="/">
                  <SellerMylistings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/seller/listings/:id"
              element={
                <ProtectedRoute allowedRoles={["seller"]} redirectTo="/">
                  <SellerListingDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/seller/requests"
              element={
                <ProtectedRoute allowedRoles={["seller"]} redirectTo="/">
                  <SellerRequests />
                </ProtectedRoute>
              }
            />
            <Route
              path="/seller/transactions"
              element={
                <ProtectedRoute allowedRoles={["seller"]} redirectTo="/">
                  <SellerTransactions />
                </ProtectedRoute>
              }
            />
            <Route
              path="/seller/transactions/:id/invoice"
              element={
                <ProtectedRoute allowedRoles={["seller"]} redirectTo="/">
                  <SellerInvoice />
                </ProtectedRoute>
              }
            />

            {/* admin Routes */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute allowedRoles={["admin"]} redirectTo="/">
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/users"
              element={
                <ProtectedRoute allowedRoles={["admin"]} redirectTo="/">
                  <AdminUsers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/transactions"
              element={
                <ProtectedRoute allowedRoles={["admin"]} redirectTo="/">
                  <AdminTransactions />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/reports"
              element={
                <ProtectedRoute allowedRoles={["admin"]} redirectTo="/">
                  <AdminReports />
                </ProtectedRoute>
              }
            />

            {/* super_admin Routes */}
            <Route
              path="/super-admin"
              element={
                <ProtectedRoute allowedRoles={["super_admin"]} redirectTo="/">
                  <SuperAdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/super-admin/users"
              element={
                <ProtectedRoute allowedRoles={["super_admin"]} redirectTo="/">
                  <SAUsers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/super-admin/transactions"
              element={
                <ProtectedRoute allowedRoles={["super_admin"]} redirectTo="/">
                  <SATransactions />
                </ProtectedRoute>
              }
            />
            <Route
              path="/super-admin/reports"
              element={
                <ProtectedRoute allowedRoles={["super_admin"]} redirectTo="/">
                  <SAReports />
                </ProtectedRoute>
              }
            />
            <Route
              path="/super-admin/admins"
              element={
                <ProtectedRoute allowedRoles={["super_admin"]} redirectTo="/">
                  <SAAdmins />
                </ProtectedRoute>
              }
            />
            <Route
              path="/super-admin/logs"
              element={
                <ProtectedRoute allowedRoles={["super_admin"]} redirectTo="/">
                  <SALogs />
                </ProtectedRoute>
              }
            />

            {/* Default redirect */}
            <Route path="/" element={<Navigate to="/" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />

            {/* common router */}
            <Route
              path="/my-profile"
              element={
                <ProtectedRoute
                  allowedRoles={["seller", "buyer", "admin", "super_admin"]}
                  redirectTo="/"
                >
                  <SellerMyProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/account-details"
              element={
                <ProtectedRoute
                  allowedRoles={["seller", "buyer", "admin", "super_admin"]}
                  redirectTo="/"
                >
                  <SellerAccountDetails />
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
